import { Chip, Avatar, Tooltip } from '@mui/material';
import { useResource } from '@app/misc/useResource';
import { MissionTypeId, MissionTypeLight } from '@wwf/sdk';
import { useMissionTypes } from '@app/mission_type/useMissionType';
import { ReactElement } from 'react';

export const MissionTypeChip = ({ type }: { type: MissionTypeLight }) => {
    const { data: iconSrc } = useResource(type.icon?.id);

    if (!type) return null;

    return (
        <Chip
            label={type.name}
            size="small"
            icon={
                iconSrc ? (
                    <Avatar
                        src={iconSrc}
                        variant="rounded"
                        sx={{ width: 20, height: 20 }}
                    />
                ) : undefined
            }
        />
    );
};

export const MissionTypeChipFromId = ({
    id,
    compressed,
}: {
    id: MissionTypeId;
    compressed?: boolean;
}) => {
    const { data: missionTypes = [] } = useMissionTypes();
    const type = missionTypes.find(m => m.id === id);

    const { data: src } = useResource(type?.icon?.id);

    if (!type) return null;

    const wrapCompressed = (node: ReactElement) =>
        compressed ? (
            <Tooltip title={type.name} placement="top">
                {node}
            </Tooltip>
        ) : (
            node
        );

    return wrapCompressed(
        <Chip
            label={compressed ? type.name.slice(0, 1) : type.name}
            size="small"
            icon={
                src ? (
                    <Avatar
                        src={src}
                        variant="rounded"
                        sx={{ width: 20, height: 20 }}
                    />
                ) : undefined
            }
        />
    );
};
